/**
 * Mock 模块：union_city_war_pk_search
 * @see mockMd/union_city_war_pk_search.md
 */
import {storiesAvatar} from '../components/PkBattleDrawer/stories-images'
import type {UnionCityWarPkListData, UnionCityWarPkSideItem} from '../types'

const MOCK_USER_AVATAR = storiesAvatar

const pkSide = (
  id: number,
  name: string,
  score: number,
  robot = false
): UnionCityWarPkSideItem => ({
  union_id: id,
  union_name: name,
  union_avatar: MOCK_USER_AVATAR,
  city_score: score,
  is_robot: robot,
})

export const UnionCityWarPkSearchHitMock: UnionCityWarPkListData = {
  err_msg: '',
  page: 1,
  more: false,
  list: [
    {
      left: pkSide(100001, 'USER NAME US...', 200000),
      right: pkSide(100001, 'USER NAME US...', 300000),
    },
  ],
}

export const UnionCityWarPkSearchEmptyMock: UnionCityWarPkListData = {
  err_msg: 'This guild is not in a PK',
  page: 1,
  more: false,
  list: [],
}

export const UnionCityWarPkSearchMock = UnionCityWarPkSearchHitMock
